import h, { FunctionComponent } from 'preact';
import classNames from 'classnames';

const Checkout: FunctionComponent<CheckoutProps> = ({ canCheckout }) => {
    return <div class="col-12 col-md-6 col-lg-3 text-right p-0">
            <a
                href="/checkout"
                id="js-checkout-button"
                class={classNames('btn', 'btn-primary', 'w-100 py-3', { 'disabled': !canCheckout, 'js-link-disabled': !canCheckout })}
                disabled={!canCheckout}
                aria-disabled={!canCheckout ? 'true' : 'false'}
            >
                <span>Checkout</span>
            </a>
        </div>
    ;
};

interface CheckoutProps {
    canCheckout: boolean;
}

export default Checkout;
